'use strict';
import {DatePicker} from './DatePicker';


DatePickerController.$inject = [
  '$modal',
  '$scope',
  'currentValue',
];

export function DatePickerController(
  $modal,
  $scope,
  currentValue,
) {
  const ctrl = $scope.datePicker = this;

  this.cancel = $modal.cancel;

  document.body.addEventListener('click', _onKeydown);
  $scope.$on('$destroy', () => document.body.removeEventListener('keydown', _onKeydown));

  this.picker = new DatePicker(
    value => $modal.hide(value),
    currentValue,
  );
  this.picker.init();

  function _onKeydown($event) {
    $scope.$evalAsync(() => {
      const shiftPressed = !!$event.shiftKey;
      switch ($event.keyCode) {
        case 27:
          $modal.hide(ctrl.value);
          break;

        case 37:
          shiftPressed ? $scope.datePicker.init(0, -1) : $scope.datePicker.init(-1, 0);
          break;

        case 39:
          shiftPressed ? $scope.datePicker.init(0, 1) : $scope.datePicker.init(1, 0);
          break;

        default:
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/js/core-components/android-date-time-pickers/DatePickerController.js